import React, { FC, memo, useCallback, useContext } from 'react'

import { useMutation } from '@apollo/client'

import { AppContext, APPLY_GIFT_CARD } from 'Const'
import useInputMask from 'Hooks/useInputMask'

import GCButton from './GCButton'

// Gift cards area
const GiftCardsArea: FC = () => {
  const { cart } = useContext(AppContext)
  const { appliedGiftCards } = cart
  const inputRef = useInputMask('&&&& &&&& &&&& &&&&', {
    autoUnmask: true,
    showMaskOnHover: false,
  })

  const [applyGiftCard] = useMutation(APPLY_GIFT_CARD)

  const onButtonClick = useCallback(
    () => applyGiftCard({ variables: { code: inputRef.current?.value } }),
    [applyGiftCard, inputRef],
  )

  return (
    <div className="my-3">
      <div className="input-group / gap-1">
        <input ref={inputRef} className="form-control" placeholder="Enter a gift card number" />
        <div className="input-group-append">
          <button className="btn btn-accent / py-1 / text-uppercase" type="button" onClick={onButtonClick}>
            Apply
          </button>
        </div>
      </div>

      {appliedGiftCards.length > 0 && (
        <div className="checkout-order__active-cards / mt-3">
          {appliedGiftCards.map((appliedGiftCard) => (
            <GCButton key={appliedGiftCard.id} cardLast4={appliedGiftCard.cardLast4} id={appliedGiftCard.id} />
          ))}
        </div>
      )}
    </div>
  )
}

export default memo(GiftCardsArea)
